export const alLocale = {
	months: [
		"Janar",
		"Shkurt",
		"Mars",
		"Prill",
		"Maj",
		"Qershor",
		"Korrik",
		"Gusht",
		"Shtator",
		"Tetor",
		"Nëntor",
		"Dhjetor",
	],
	monthsShort: ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Kor", "Gus", "Sht", "Tet", "Nën", "Dhj"],
	weekdays: ["E Diel", "E Hënë", "E Martë", "E Mërkurë", "E Enjte", "E Premte", "E Shtunë"],
	weekdaysShort: ["Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Sht"],
	weekdaysMin: ["D", "H", "M", "M", "E", "P", "S"],
	longDateFormat: {
		LT: "HH:mm",
		LTS: "HH:mm:ss",
		L: "DD.MM.YYYY",
		LL: "D MMMM YYYY",
		LLL: "D MMMM YYYY HH:mm",
		LLLL: "dddd, D MMMM YYYY HH:mm",
	},
	calendar: {
		sameDay: "[Sot në] LT",
		nextDay: "[Nesër në] LT",
		nextWeek: "dddd [në] LT",
		lastDay: "[Dje në] LT",
		lastWeek: "[Të kaluarën] dddd [në] LT",
		sameElse: "L",
	},
	relativeTime: {
		future: "në %s",
		past: "%s më parë",
		s: "disa sekonda",
		ss: "%d sekonda",
		m: "një minutë",
		mm: "%d minuta",
		h: "një orë",
		hh: "%d orë",
		d: "një ditë",
		dd: "%d ditë",
		M: "një muaj",
		MM: "%d muaj",
		y: "një vit",
		yy: "%d vjet",
	},
	dayOfMonthOrdinalParse: /\d{1,2}\./,
	ordinal: (n: number) => `${n}.`,
	week: {
		dow: 1, // Monday is the first day of the week.
		doy: 4, // The week that contains Jan 4th is the first week of the year.
	},
};
